export default __webpack_public_path__ + "static/media/search-icon.01abd853.png";